import {
    CRON_JOBS_ENDPOINT,
    CRON_JOB_BY_ID_ENDPOINT,
    CRON_JOB_TOGGLE_ENDPOINT,
    CRON_JOBS_RELOAD_ENDPOINT,
    CRON_EXPRESSION_HELP_ENDPOINT
} from "../api-services/ApiEndpoints";

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export const getAllCronJobs = async () => {
    const url = `${process.env.REACT_APP_API_URL}${CRON_JOBS_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch cron jobs: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get cron jobs error:', error);
        throw error;
    }
};

export const getCronJobById = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}${CRON_JOB_BY_ID_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch cron job: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get cron job error:', error);
        throw error;
    }
};

export const createCronJob = async (jobData) => {
    const url = `${process.env.REACT_APP_API_URL}${CRON_JOBS_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify(jobData)
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to create cron job: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Create cron job error:', error);
        throw error;
    }
};

export const updateCronJob = async (id, jobData) => {
    const url = `${process.env.REACT_APP_API_URL}${CRON_JOB_BY_ID_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: getAuthHeaders(),
            body: JSON.stringify(jobData)
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to update cron job: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Update cron job error:', error);
        throw error;
    }
};

export const toggleCronJob = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}${CRON_JOB_TOGGLE_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'PATCH',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to toggle cron job: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Toggle cron job error:', error);
        throw error;
    }
};

export const deleteCronJob = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}${CRON_JOB_BY_ID_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to delete cron job: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Delete cron job error:', error);
        throw error;
    }
};

export const reloadCronJobs = async () => {
    const url = `${process.env.REACT_APP_API_URL}${CRON_JOBS_RELOAD_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to reload cron jobs: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Reload cron jobs error:', error);
        throw error;
    }
};

export const getCronExpressionHelp = async () => {
    const url = `${process.env.REACT_APP_API_URL}${CRON_EXPRESSION_HELP_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch cron help: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get cron help error:', error);
        throw error;
    }
};
